<!-- 设备状态信息上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportEquipmentStatus",
                "parkCode": "2KM43Y461",
                "reportTime": "20170929170010",
                "statusList": [
                    {
                        "equipList": [
                            {
                                "equipSeq": 1,
                                "equipType": 1,
                                "statusDesc": "1"
                            },
                            {
                                "equipSeq": 2,
                                "equipType": 1,
                                "statusDesc": "1"
                            },
                            {
                                "equipSeq": 8,
                                "equipType": 1,
                                "statusDesc": "1"
                            },
                            {
                                "equipSeq": 9,
                                "equipType": 1,
                                "statusDesc": "1"
                            },
                            {
                                "equipSeq": 17,
                                "equipType": 1,
                                "statusDesc": "1"
                            },
                            {
                                "equipSeq": 18,
                                "equipType": 1,
                                "statusDesc": "1"
                            },
                            {
                                "equipSeq": 1,
                                "equipType": 0,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 2,
                                "equipType": 0,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 3,
                                "equipType": 0,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 4,
                                "equipType": 0,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 1,
                                "equipType": 2,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 2,
                                "equipType": 2,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 3,
                                "equipType": 2,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 4,
                                "equipType": 2,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 1,
                                "equipType": 3,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 2,
                                "equipType": 3,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 3,
                                "equipType": 3,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 4,
                                "equipType": 3,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 1,
                                "equipType": 5,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 2,
                                "equipType": 5,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 3,
                                "equipType": 5,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 4,
                                "equipType": 5,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 1,
                                "equipType": 6,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 2,
                                "equipType": 6,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 3,
                                "equipType": 6,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 4,
                                "equipType": 6,
                                "statusDesc": "2"
                            },
                            {
                                "equipSeq": 1,
                                "equipType": 6,
                                "statusDesc": "0"
                            },
                            {
                                "equipSeq": 2,
                                "equipType": 6,
                                "statusDesc": "0"
                            }
                        ],
                        "parkingLotId": "2KM43Y461"
                    }
                ]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场设备状态信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportEquipmentStatus",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'reportTime', info2: '是', info3: 'String', info4: '上报时间，yyyyMMddHHmmss' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'statusList', info2: '是', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'statusList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingLotId', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'equipList', info2: '否', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'equipList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'equipType', info2: '是', info3: 'int', info4: '设备类型：0主控板,1通道,2摄像枪,3显示屏,4环境枪,5语音版,6转换板,7卡票机' },
                        { info1: 'equipSeq', info2: '是', info3: 'int', info4: '该设备在停车场端的唯一序列号' },
                        { info1: 'statusDesc', info2: '是', info3: 'String', info4: '状态描述：equipType=0:(0未启用，1离线，2在线，3禁用)；equipType=1:(0禁用，1启用)；equipType=2:(0未启用，1离线，2在线，3禁用，4启用)；equipType=3:(0未启用，1离线，2在线，3禁用，4启用)；equipType=4:(0未启用，1离线，2在线，3禁用，4启用)；equipType=5:(0未启用，1离线，2在线，3禁用，4启用)；equipType=6:(0未启用，1离线，2在线，3禁用，4启用)；equipType=7:(0x00:操作正常,0x01:发卡机出卡失败,0x02:发卡机出卡堵塞,0x03:发卡机发卡器回收仓已满,0x04:发卡机发卡仓卡量少,0x05:发卡机发卡仓空,0x06:预发卡失败,0x07:超时取卡,0x80:收卡失败,0x81:收卡机收卡时超时或堵塞,0x82:收卡机退卡时超时或堵塞,0x83:收卡机收卡仓已满)' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportEquipmentStatus.vue